import { render, staticRenderFns } from "./ModalPilihAnggota.vue?vue&type=template&id=40bed95c&"
import script from "./ModalPilihAnggota.vue?vue&type=script&lang=js&"
export * from "./ModalPilihAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports